import { takeLatest } from "redux-saga/effects";

import {
  GET_CADERNOS_ENCARGOS,
  CREATE_NEW_CADERNO_ENCARGOS,
  GET_CVS,
  CREATE_NEW_CV,
  GENERATE_CV_PROMPT,
  GET_SPECIFIC_CV,
  UPDATED_CV,
  GET_SPECIFIC_ENCARGO,
  UPDATED_ENCARGO,
  GET_PROFILES_BY_ENCARGO
} from "../ducks/cvManagement/actionTypes";

import {
  getCadernosEncargos,
  createNewCadernoEncargos,
  getCvs,
  getSpecificCv,
  createNewCVS,
  updateCv,
  generateCVPrompt,
  getSpecificEncargo,
  updateEncargo,
  getProfilesByEncargo
} from "../ducks/cvManagement/sagas";

export const cvManagementSagas = [
  takeLatest(GET_CADERNOS_ENCARGOS, getCadernosEncargos),
  takeLatest(CREATE_NEW_CADERNO_ENCARGOS, createNewCadernoEncargos),
  takeLatest(GET_CVS, getCvs),
  takeLatest(CREATE_NEW_CV, createNewCVS),
  takeLatest(GET_SPECIFIC_CV, getSpecificCv),
  takeLatest(UPDATED_CV, updateCv),
  takeLatest(GET_SPECIFIC_ENCARGO, getSpecificEncargo),
  takeLatest(UPDATED_ENCARGO, updateEncargo),
  takeLatest(GENERATE_CV_PROMPT, generateCVPrompt),
  takeLatest(GET_PROFILES_BY_ENCARGO, getProfilesByEncargo)
];
